import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, InputNumber, DatePicker, Upload, Icon, Tag, Tabs, notification, Row, Col, Typography, Switch, Carousel } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import Format from '../../../utils/format';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './updateretailoffer.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

const { Search, TextArea } = Input;
const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'webSettingStore',
    'retailOfferStore'
)
@observer
class UpdateRetailOfferModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false
        };
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
        this.props.webSettingStore.getData();
    }

    // ON CLICK

    deleteBannerOnClick = () => {
        this.props.retailOfferStore.setImageUrl('');
    }

    useItemImageOnClick = () => {
        this.props.retailOfferStore.setImageUrlAsOriginalImageUrl();
    }

    createClicked = () => this.props.retailOfferStore.createRetailOffer();
    updateClicked = () => this.props.retailOfferStore.updateRetailOffer();
    cancelClicked = () => this.props.retailOfferStore.setShowUpdateRetailOfferModal(false);

    // ON CHANGE

    titleOnChange = (langId, e) => {
        this.props.retailOfferStore.setRetailOfferLanguageTitle(langId, e.target.value);
    }

    briefDescOnChange = (langId, e) => {
        this.props.retailOfferStore.setRetailOfferLanguageBriefDesc(langId, e.target.value);
    }

    descriptionOnChange = (langId, data) => {
        this.props.retailOfferStore.setRetailOfferLanguageDescription(langId, data);
    }

    priceChange = (value) => this.props.retailOfferStore.setPrice(value);
    showBannerOnlyOnChange = (value) => this.props.retailOfferStore.setShowBannerOnly(value);

    handleStartDateChange = (e) => this.props.retailOfferStore.setStartDate(e);
    handleStartTimeChange = (e) => this.props.retailOfferStore.setStartTime(e);
    handleEndDateChange = (e) => this.props.retailOfferStore.setEndDate(e);
    handleEndTimeChange = (e) => this.props.retailOfferStore.setEndTime(e);

    itemSearched = () => {
        this.props.retailOfferStore.setItemSearchValue('');
        this.props.retailOfferStore.searchItem('');
        this.props.retailOfferStore.setShowSearchMenuItemModal(true);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller or equal to 1MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.retailOfferStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.retailOfferStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'RetailOffer'
                const titleName = Format.RemoveSpecialChars(title) || 'Default'

                ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.retailOfferStore.setImageUrlById(id, response.imageUrl)
                    this.props.retailOfferStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const { data: webSettting } = this.props.webSettingStore;
        const { t } = this.props;

        const {
            retailOfferId,
            taskName,
            title,
            briefDesc,
            description,
            retailOfferLanguages,
            updateLoading,
            originalPrice,
            price,
            startDate,
            startTime,
            endDate,
            endTime,
            // imageUrl,
            images,
            // originalImageUrl,
            showBannerOnly,
            sort
        } = this.props.retailOfferStore;

        let hasError = true;
        const primaryLang = retailOfferLanguages.find(lang => lang.langId === 1);

        if (showBannerOnly) {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null;
        } else {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null &&
                primaryLang && primaryLang.title !== '' &&
                primaryLang && primaryLang.briefDesc !== '' &&
                primaryLang && primaryLang.description !== '';
        }

        if (updateLoading) {
            Toast.loading(t('Saving...'), 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Form layout='vertical'>

                                <Form.Item label={t('Item Name')}>
                                    <Search
                                        placeholder={t('search item')}
                                        value={taskName}
                                        onSearch={() => this.itemSearched(true)}
                                        enterButton
                                    />
                                </Form.Item>

                                <>
                                    {
                                        images.map(image => {
                                            return (
                                                <Form.Item key={image.id} label={
                                                    image.url === ''
                                                        ?
                                                        t('Create Banner')
                                                        :
                                                        <>
                                                            <Row className='updateretailoffer-row-label'>
                                                                <Col span={18} className='updateretailoffer-col-label'>{t('Update Banner')}</Col>
                                                                <Col span={6} className='updateretailoffer-col-label-button'>
                                                                    <Button type='danger' onClick={() => this.props.retailOfferStore.removeImageById(image.id)}>{t('Delete')}</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }>
                                                    <Upload
                                                        listType='picture-card'
                                                        className='avatar-uploader'
                                                        showUploadList={false}
                                                        customRequest={this.dummyRequest}
                                                        beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                        onChange={(info) => this.uploadChange(info, image.id, title)}
                                                    >
                                                        {
                                                            image.url !== ''
                                                                ?
                                                                <img src={image.url} alt='avatar' className='updateretailoffer-img' />
                                                                :
                                                                <div>
                                                                    <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                    <div className='ant-upload-text'>{t('Upload')}</div>
                                                                </div>}
                                                    </Upload>
                                                </Form.Item>
                                            )
                                        })
                                    }
                                </>

                                <Form.Item label={t('Show Banner Only')}>
                                    <Switch checkedChildren={t('Yes')} unCheckedChildren={t('No')} checked={showBannerOnly} onChange={this.showBannerOnlyOnChange} />
                                </Form.Item>

                                <Form.Item label={t('Sort')}>
                                    <InputNumber
                                        className='stm-width-100'
                                        value={sort}
                                        onChange={(value) => this.props.retailOfferStore.setsort(value)}
                                        min={0}
                                    />
                                </Form.Item>

                                <React.Fragment>
                                    {
                                        showBannerOnly
                                            ?
                                            null
                                            :
                                            <Tabs defaultActiveKey='1'>
                                                {
                                                    activeLanguages && activeLanguages.map(lang => {
                                                        const langData = retailOfferLanguages.find(rol => rol.langId === lang.id);
                                                        const isPrimary = lang.id === 1; // English is primary
                                                        return (
                                                            <TabPane
                                                                tab={`${lang.originalName}${isPrimary ? ' *' : ''}`}
                                                                key={lang.id.toString()}
                                                            >
                                                                <Form.Item label={t('Title')} className='mg-b-10'>
                                                                    <Input
                                                                        placeholder={t('Insert title')}
                                                                        value={langData ? langData.title : ''}
                                                                        onChange={(e) => this.titleOnChange(lang.id, e)}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                    <TextArea
                                                                        rows={3}
                                                                        maxLength={100}
                                                                        placeholder={t('Insert brief description')}
                                                                        value={langData ? langData.briefDesc : ''}
                                                                        onChange={(e) => this.briefDescOnChange(lang.id, e)}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label={t('Description')} className='mg-b-10'>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={langData ? langData.description : ''}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            this.descriptionOnChange(lang.id, data);
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </TabPane>
                                                        );
                                                    })
                                                }


                                            </Tabs>
                                    }
                                </React.Fragment>

                                <div style={{ borderBottom: '2px solid #1890ff', marginBottom: 20 }} />

                                <Form.Item label={t('Original Price')}>
                                    <Tag color={'blue'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}
                                    </Tag>
                                </Form.Item>

                                <Form.Item label={t('Special Price')}>
                                    <InputNumber
                                        value={price}
                                        onChange={this.priceChange}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>

                                <Form.Item label={t('Start Date Time')}>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={startDate}
                                        onChange={(e) => this.handleStartDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='startdatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={startTime}
                                            onChange={(e) => this.handleStartTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': t('change time'),
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label={t('End Date Time')}>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={endDate}
                                        onChange={(e) => this.handleEndDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='enddatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={endTime}
                                            onChange={(e) => this.handleEndTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': t('change time'),
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label={t('Preview Banner')}>
                                    <Row>
                                        <Col span={24} className='updateretailoffer-col-preview-container'>
                                            {
                                                images.length === 1
                                                    ?
                                                    null
                                                    :
                                                    <Row>
                                                        <Col className='updateretailoffer-col-preview-img'>
                                                            <Row>
                                                                <Col
                                                                    span={24}
                                                                    className={images.length === 2 ? 'updateretailoffer-col-carousel-container-single' : 'updateretailoffer-col-carousel-container'}
                                                                >
                                                                    <Carousel>
                                                                        {
                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                return (
                                                                                    <div key={image.id} className='updateretailoffer-div-carousel'>
                                                                                        <Row className='updateretailoffer-row-carousel'>
                                                                                            <Col span={24} className='updateretailoffer-col-carousel'>
                                                                                                <img className='updateretailoffer-img-carousel' src={image.url} alt={image.id} />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Carousel>
                                                                </Col>
                                                            </Row>
                                                            <React.Fragment>
                                                                {
                                                                    showBannerOnly
                                                                        ?
                                                                        null
                                                                        :
                                                                        <Row className='updateretailoffer-row-detail'>
                                                                            <Col span={24} className='updateretailoffer-col-preview-title'>
                                                                                <Text className='updateretailoffer-text-preview-title'>{title}</Text>
                                                                            </Col>
                                                                            <Col span={24} className='updateretailoffer-col-preview-date'>
                                                                                <Row>
                                                                                    <Col span={11} className='txt-algn-right'>
                                                                                        <Tag color={'blue'} className='fnt-8 mg-0' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(startDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                    <Col span={2} className='txt-algn-center'>
                                                                                        <Text>-</Text>
                                                                                    </Col>
                                                                                    <Col span={11}>
                                                                                        <Tag color={'blue'} className='fnt-8' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(endDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-8 txt-algn-center'>
                                                                                <Text delete>
                                                                                    <Tag color={'red'} className='fnt-8' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        <Text delete>{webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}</Text>
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-10 txt-algn-center'>
                                                                                <Text>
                                                                                    <Tag color={'green'} className='fnt-10' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        {webSettting ? webSettting.currencyCode : ''} {price ? Format.Currency(price) : ''}
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={briefDesc} />
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={description} />
                                                                            </Paragraph>
                                                                        </Row>
                                                                }
                                                            </React.Fragment>
                                                        </Col>
                                                    </Row>
                                            }
                                        </Col>
                                    </Row>
                                </Form.Item>

                                <Form.Item>
                                    {
                                        retailOfferId === 0 ? (
                                            <Button onClick={this.createClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>{t('Create')}</Button>
                                        ) : (
                                            <Button onClick={this.updateClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>{t('Update')}</Button>
                                        )
                                    }

                                    <Button onClick={this.cancelClicked}>{t('Cancel')}</Button>
                                </Form.Item>
                            </Form>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(UpdateRetailOfferModal)